import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Route from './routes';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { ToastContainer } from 'react-toastify';
import { ContactProvider } from './components/function/Contact'
function App() {
    return (
        <ContactProvider>
            <ToastContainer />
            <RouterProvider router={createBrowserRouter(Route)} />
        </ContactProvider>
    );
}

export default App;